<ng-container *ngIf="searchList$ | async as list">
  <h2 class="title">{{ '+SEARCH.SEARCH_HISTORY.TITLE' | translate }}</h2>
  <div class="list-item-header !hidden gt-xs:!flex flex-row justify-start items-end">
    <div class="flex-[25%] max-w-[25%]">{{ '+SEARCH.SEARCH_HISTORY.TYPE' | translate }}</div>
    <div class="flex-[50%] max-w-[50%]">{{ '+SEARCH.SEARCH_HISTORY.KEYWORD' | translate }}</div>
    <div class="flex-[25%] max-w-[25%]">{{ '+SEARCH.SEARCH_HISTORY.TIME_STAMP' | translate }}</div>
  </div>

  <div *ngFor="let item of list">
    <!-- Desktop View -->
    <div
      class="list-item !hidden gt-xs:!flex flex-row justify-start items-center"
      gtm="invokeHistorySearch"
      (click)="invokeSearch(item)"
    >
      <div class="flex flex-row justify-start items-center flex-[25%] max-w-[25%]">
        <vi-icon class="type-icon" icon [name]="getIconBasedOnType(item.type)" [size]="18"></vi-icon
        >{{ item.type | translateSearchListType }}
      </div>
      <div class="search-params flex-[50%] max-w-[50%]">
        {{ item.searchParams | searchParamsAsText }}
      </div>
      <div class="flex-[25%] max-w-[25%]">{{ item.timestamp | date: 'short' }}</div>
    </div>

    <!-- Mobile View -->
    <div
      class="list-item gt-xs:!hidden flex flex-row gap-[18px] justify-start items-start"
      gtm="invokeHistorySearch"
      (click)="invokeSearch(item)"
    >
      <vi-icon icon [name]="getIconBasedOnType(item.type)" [size]="20"></vi-icon>
      <div class="flex flex-col gap-[24px]">
        <div>{{ item.type }}</div>
        <div>{{ item.searchParams | searchParamsAsText }}</div>
        <div>{{ item.timestamp | date: 'short' }}</div>
      </div>
    </div>
  </div>
</ng-container>
